import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { consoleLog, getGlobalSettingValue, getItemOfSessionStorage, isContainAlphabet } from '../../services/common/utils';
import RectcardComponent from '../home/accordion/rect-card';
import SquarecardComponent from '../home/accordion/sqaure-card';
import ProceedASComponent from './bottom-modal-proceed-as';
import VideoModalComponent from "../../components/common/video-modal";
import { IS_2FA_DONE, SELECTED_LANG } from '../../services/common/Constants';
import HotDealsCard from '../nojoom/hot-deals-card';
import PartnersCard from '../nojoom/partners-card';
import ServicesCard from '../nojoom/services-card';
import EarnPoints from '../nojoom/earn-points-card';
import TransferPointsCard from '../nojoom/transfer-points-card';
import { setAuthModalContent, setShowAuthModal, setShowEnableMediumAuthBtn, setShowGetKuwaitAppBtn } from '../../reducer/utilitySlice';
import { setClickedTrasferPointsCardData } from '../../reducer/nojoomSlice';
import { useSelector } from 'react-redux';
import { RecordlogEvents } from '../../analytics/RecordEvents'
import { GTM_Select_Item } from "../../../src/analytics/GoogleTagManager";
import MessageModal from './bottom-modal-message';
import { CT_Events } from "../../analytics/CTEvents";
import {redirecturl} from "../../services/common/redirect"
import { getImgSrc, getformatedMsisdn } from '../../services/common/CommonUtils';
import { RC4Encrypt } from '../../services/common/RC4EncDec';
import ExclusiveModal from "../common/exclusive-modal";
import { Modal } from 'react-bootstrap';
import ViewSupportedCountriesSlider from '../home/viewPacks/ViewSupportedCountriesSlider';
import parse from 'html-react-parser';
import BottomModalComponent from './bottom-modal';
const CardsComponent = ({ type, data, psmItem, categoryId, categoryId_ar, categoryId_en, bgColor="", sourceId={}, giftnumber }) => {

    //Instal rect-bootstrap first then call this code
    const [showModal, setShowModal] = useState(false);
    const [deeplinktext, setDeeplinktext] = useState("");
    const [recentModal, setRecentModal] = useState(false);
    const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
    const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
   const loginmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
   const [showBottomModal, setShowBottomModal] = useState(false);
   const [showInfoModal, setShowInfoModal] = useState(false);
   const location = useLocation()
    const { CT_ProductViewed } = CT_Events();

    const toggleModal = () => {
        // console.log(`toggle modal...`);
        setShowModal(!showModal);
    };

    const recnetTogalModal = () => {
    //   console.log(`toggle modal...`);
        setRecentModal(!recentModal);
    };
    const { t } = useTranslation()

    const {
        utilityData: { globalSetting },
      } = useSelector((state) => state);
    const dispatch = useDispatch();
    const customerprofile = useSelector(
        (state) => state?.userdata?.value?.customerprofile
      );

    const [problems, setProblems] = useState(false)

    const getGeloLocation = (data) => {
        //console.log(data, "datere")
        navigator.geolocation.getCurrentPosition(function (position) {
            // console.log("Latitude is :", position.coords.latitude);
            data.location({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            })
            //console.log("Longitude is :", position.coords.longitude);
        });
    }

    const navigate = useNavigate()
    const { categoryID } = useParams()

    //Special deals
    if (type === 1) {

        const handleViewDealClick = (e) => {
            e.preventDefault();
            GTM_Select_Item(data, "SpecialDealsPrePaid");
            navigate('/ooredoo-surprise');
        }

        return <div className="card_style_1 height_100" onClick={handleViewDealClick}>
            <div className="card_offer">
                <h4>{data?.tag_text}</h4>
            </div>
            <div className="card_img">
                <img src={data?.imagepath || process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'} alt="" title="" />
            </div>
            <div className="card_info text-center">
                <div className="card_info_grp">
                    <h4 className="text-ellipsis">{data?.tag_text}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link">
                    <a href="#" className="hyperlink" onClick={handleViewDealClick}>
                        {data?.action_button_text}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </a>
                </div>
            </div>
        </div>
    }
    if (type === 2) {
        //console.log(data, "dfarer")
        const isChangePlan = location?.state?.isChangePlan === true ? true : false;
        const isBuyPlan = location?.state?.isBuyPlan === true ? true : false;

        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            try {
                GTM_Select_Item(data, data.category === 'addons' ? "addons" : "bundles")
            } catch { }
            // console.log(data, "data.id")
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            if (data.category === 'bundles') {
                // before
                // navigate(`/bundles-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })

                // sprint-16
                const dataAlt = {...data, isChangePlan, isBuyPlan};
                navigate(`/bundles-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: dataAlt })
            } else if (data.category === 'addons') {
                navigate(`/addons-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })
            }
        }
        const imagePath = data?.imageurl || data?.imagepath;
        return <div className="card_style_2 height_100 pointer" onClick={() => addonFunction(data)}>
            <div className="card_img">
                {data?.fifa && <div className="offer_placeholder end-0 top-0">
                    <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                </div>}
                <img 
                // src={data?.imageurl !== undefined ? data?.imageurl : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')}
                src={getImgSrc(imagePath, true)}
                alt="" title="" />
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.title}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                   
                    <div className="amount_stripe me-2">
                        {data?.offerdiscountprice !== "" && `KD${data?.offerbaseprice}`}
                    </div>
                       
                    <div className="hyperlink">
                        {GetMoreText(data)}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>
    }

    if (type === 3) {
        return <div className="card_style_2 height_100">
            <div className="card_img">
                <img src={process.env.PUBLIC_URL + '/assets/images/s-internet.svg'} alt="" title="" />
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>5G Routes</h4>
                    <p>Fast 5G Internet<br></br> Starting From</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    {/* <div className="amount_stripe me-2">
                                23 KD /month
                            </div> */}
                    <a href="bundles.html" className="hyperlink">
                        KD 14/<span className="text-lowercase">month</span>
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </a>
                </div>
            </div>
        </div>
    }

    if (type === 4) {
        const handleViewDealClick = (e) => {
            e.preventDefault();
            try {
                GTM_Select_Item(data, "DigitalServices");
                CT_ProductViewed(data, "DigitalServices");
            } catch { }
            navigate(
                `/digitalservices-detail/${data.id !== undefined ? data.id : data?.offerdiscategory
                }`,
                { state: data }
            )
        };

        return (
            <div
                className="card_style_2 height_100 pointer"
                onClick={handleViewDealClick}
            >
                <div className="card_img">
                {data?.bestseller === "True" && (
                        <div className="offer-icon-tag">
                            <img
                                src={process.env.PUBLIC_URL + '/assets/images/star.svg'}
                                alt=""
                                title=""
                            />
                        </div>
                    )}

                    <img src={data?.thumbnail} alt="" title="" />
                </div>
                <div className="card_info">
                    <div className="card_info_grp">
                        <h4>{data?.name}</h4>

                        <h6>
                            {data?.currency || ''} {data?.price || ''} {data?.validity && `/${data?.validity?.toString()?.toLowerCase()}` || ''}
                        </h6>
                    </div>
                    <div className="card_link flex_grp_align_center">
                        <div className="hyperlink">
                            {data?.buttontext}
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    '/assets/images/right_arrow_red.svg'
                                }
                                alt=""
                                title=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (type === 5) {
        return <div className="card_style_3 height_100">
            <div className="card_img">
                <img src={process.env.PUBLIC_URL + '/assets/images/device.png'} alt="" title="" />
            </div>
            <div className="card_info text-center">
                <div className="card_info_grp">
                    <h4>RedMagic 5S 5G</h4>
                    <p>256GB GB</p>
                </div>
                <div className="card_link">
                    <div className="amount_stripe">
                        23 KD /month
                    </div>
                    <a href="#" className="hyperlink">
                        KD19/<span className="text-lowercase">month</span>
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </a>
                </div>
            </div>
        </div>
    }

    // for special offers at home page
    if (type === 6) {
        const handleViewDealClick = (e) => {
            e.preventDefault();
            navigate(`/special-offer-deals-detail/${data?.offerid}`, {
                state: { psmItem: psmItem },
            })
        };

        return <div onClick={handleViewDealClick}>
            <div class="dls13_card_style2 mb-2">
                <div class="d-flex card_style_2 height_100 align-item-center">
                    <div class="com-wl">
                        <div class="sec001">
                            <div class="card_img">
                                <img src={data?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
                            </div>
                            <div class="card_info">
                                <div class="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-1">{data?.description}</p>
                    </div>


                    <div class="vr"></div>

                    <div class="card_link flex_grp_align_center com-wr">
                        <a class="hyperlink">
                            {data?.currency} {data?.offerdiscountprice || data?.offerbaseprice || ''}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    }

    if (type === 7) {
        return <div className="roaming-rates-col">
            <div className="d-flex align-items-center img-size01">
                <img src="assets/images/country-logos/Afghanistan-sm.png" alt="" title="" /> Egypt(+20)
            </div>
            <div className="right-arrow">
                <img src="assets/images/icon/arrow_right_dark.svg" alt="" title="" />
            </div>
        </div>
    }

    if (type === 8) {
        return <div className="card_style_2 height_100">
            <div className="card_img">
                <img src={process.env.PUBLIC_URL + '/assets/images/Azerbaijan.png'} alt="" title="" />
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>My country use deal</h4>
                    <p>100 GB Internet, Unlimited Local Minutes, Unlimited Ooredoo Minutes, Unlimited SMS</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    {/* <div className="amount_stripe me-2">
                                23 KD /month
                            </div> */}
                    <a href="bundles.html" className="hyperlink">
                        KD 8
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </a>
                </div>
            </div>
        </div>
    }
    if (type === 9) {
        return <RectcardComponent data={data} />
    }
    if (type === 10) {
        return <SquarecardComponent data={data} />
    }
    if (type === 13) {
        return <div className="card_style_5 pointer mb-10">
            <div className="card_style_5_header flex_grp_align_center">
                <div className="card_img">
                    <img src={process.env.PUBLIC_URL + '/assets/images/country-logos/Afghanistan-sm.png'} alt="" title="" />
                </div>
                <div className="card_info flex1">
                    <p>Egypt(+20)</p>
                </div>
                <div className="card_link">
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_dark.svg'} alt="" title="" />
                </div>
            </div>
        </div>
    }
    // if(type===9){
    //     return <div class="country-accro-comp">
    //     <div class="roaming-rates-col">
    //         <div class="d-flex align-items-center img-size01">
    //             <img src={process.env.PUBLIC_URL + '/assets/images/country-logos/Afghanistan-sm.png'} alt="" title="" /> Egypt(+20)
    //         </div>
    //         <div class="right-arrow">
    //             <img src={process.env.PUBLIC_URL + '/assets/images/icon/arrow_right_dark.svg'} alt="" title="" />
    //         </div>
    //     </div>
    //     </div>
    // }

    // if(type===10){
    //     return <div class="tabs-comp-two mt-2">
    //     <div class="activity-camp dark_gray_color2">
    //     <div class="country-accro-comp">
    //         <div class="mt-4 row">
    //             <div class="col-10">
    //                 <span class="primary_14"> Roaming Services </span>
    //             <div class="main_banner_comb1">
    //                 <div class="mb-0 mt-2"> By enabling this service you will be able to make international calls and SMS while roaming</div>
    //             </div>
    //             </div>
    //             <div class="col-2">
    //                 <div class="cs_toggle_btn">
    //                     <input type="checkbox" name="toggle" id="test1" />
    //                     <label for="test1">&nbsp;</label>
    //                 </div>
    //             </div>
    //         </div>                        
    //     </div>
    //     <div className='line-m'></div>

    //     <div class="country-accro-comp">
    //         <div class="row">
    //             <div class="col">
    //                 <span class="primary_14"> Supported operators Egypt </span>
    //                 <div class="mb-0 mt-2"> Etisalat, Mobinil, Vodafone </div>
    //                 <div class="mb-0 mt-2 primary_color"> Other operators are not supported in this country </div>

    //             </div>
    //         </div>                        
    //     </div>
    //     <div className='line-m'></div>

    //     <div class="d-flex align-items-center justify-content-between mt-2">
    //         <div><span class="primary_14"> Internet </span></div>
    //         <div class="primary_color"> 6,144 KD/MB </div>
    //     </div>

    //     <div class="d-flex align-items-center justify-content-between mt-2">
    //         <div> Recived </div>
    //         <div class="primary_color"> 0.6 KD/MB </div>
    //     </div>
    //     <div class="d-flex align-items-center justify-content-between mt-2">
    //         <div> To Same country </div>
    //         <div class="primary_color"> 0.300 KD/MB </div>
    //     </div>
    //     <div class="d-flex align-items-center justify-content-between mt-2">
    //         <div> Back to Kuwait </div>
    //         <div class="primary_color"> 0.65 KD/MB </div>
    //     </div>
    //     <div class="d-flex align-items-center justify-content-between mt-2">
    //         <div> To another country </div>
    //         <div class="primary_color"> 1.3 KD/MB </div>
    //     </div>
    //     <div className='line-m'></div>
    //     <div class="align-items-center justify-content-between">
    //         <div><span class="primary_14 mb-2"> SMS </span></div>
    //         <div class="d-flex align-items-center justify-content-between mt-4">
    //             <div> Sending </div>
    //             <div class="primary_color"> 0.15 KD/SMS </div>
    //         </div>
    //         <div class="d-flex align-items-center justify-content-between mt-2">
    //             <div> Recived </div>
    //             <div class="primary_color"> 0 KD/SMS </div>
    //         </div>
    //     </div>
    //     <div className='line-m'></div>
    //     <div class="text-center pb-4 mt-2">
    //         For Internet, Calls, and SMS, Pay-As-You Go rates will apply.
    //     </div>

    //     <div class="mb-5 mt-2 pb-5">
    //         <button class="custom_btn custom_btn_primary_outline btn_block" onclick="window.location.href='roaming-multi-countries.html';" >Buy Ooredoo Passport</button>
    //     </div>

    // </div>
    // </div>
    // }

    // if(type===11){
    //     return <div class="tabs-comp-two mt-2">
    //     <div class="activity-camp dark_gray_color2">
    //     <div class="country-accro-comp">
    //         <div class="mt-4 row">
    //             <div class="col-10">
    //                 <span class="primary_14"> Roaming Services </span>
    //             <div class="main_banner_comb1">
    //                 <div class="mb-0 mt-2"> By enabling this service you will be able to make international calls and SMS while roaming</div>
    //             </div>
    //             </div>
    //             <div class="col-2">
    //                 <div class="cs_toggle_btn">
    //                     <input type="checkbox" name="toggle" id="test1" />
    //                     <label for="test1">&nbsp;</label>
    //                 </div>
    //             </div>
    //         </div>                        
    //     </div>
    //     <div className='line-m'></div>

    //     <div class="d-flex align-items-center justify-content-between mt-2 mb-3">
    //         <div><span class="primary_14"> From Kuwait to Egypt </span></div>
    //     </div>

    //     <div class="d-flex align-items-center justify-content-between mt-4 mb-2">
    //         <div><span class="primary_14"> Call </span></div>
    //         <div class="primary_color"> 0.21 KD/SMS </div>
    //     </div>
    //     <div className='line-m'></div>
    //     <div class="d-flex align-items-center justify-content-between mt-2 mb-2">
    //         <div><span class="primary_14"> SMS </span></div>
    //         <div class="primary_color"> 0.05 KD/SMS </div>
    //     </div>

    //     <div className='line-m'></div>

    //     <div class="mb-5 mt-2 pb-5">
    //         <button class="custom_btn custom_btn_primary_outline btn_block" onclick="window.location.href='roaming-multi-countries.html';" >Buy Ooredoo Passport</button>
    //     </div>

    if (type === 14) {
        return <div class="roaming-rates-col1">
            <div class="d-flex align-items-center img-size01">
                <img src={process.env.PUBLIC_URL + '/assets/images/Request Status.svg'} alt="" title="" />
                <div class="subtextcomn">
                    Track request status
                    <p>1Request(s)pendings</p>
                </div>
            </div>

            <div class="right-arrow">
                <img src={process.env.PUBLIC_URL + '/assets/images/icon/arrow_right_dark.svg'} alt="" title="" />
            </div>
        </div>
    }

    if (type === 15) {
        return <div class="white_detail_card d-flex flex-column justify-content-between p-3 mb-3">
            <div class="d-flex flex-row width100 justify-content-between">
                <div>{data?.troubleticket}</div>
                <label class="primary_14">{data?.status}</label>
            </div>
            {/* {console.log(data?.status, "data?.status")} */}
            <div class="mt-4">
                {data?.status === "Assigned" && <button class="custom_btn custom_btn_primary btn_block" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" onClick={() => navigate("/help-followup", { state: data })}>{t("followupSmall")}</button>}
            </div>
        </div>
    }

    if (type === 16) {
        return <div class="roaming-rates-col p-3" onClick={() => data?.toggle()}>
            <div class="d-flex align-items-center img-size01">
                Call drop
            </div>
            <div class="right-arrow">
                <img src={process.env.PUBLIC_URL + '/assets/images/arrow_right_dark.svg'} alt="" title="" />
            </div>
            {/* <ProceedASComponent show={data?.show} toggleModal={data?.toggle} /> */}
        </div>
    }

    if (type === 17) {
        //console.log(data.phoneNumber, "e.target/value")
        const crrdata = data.stepsdata[0]?.metainfo.filter(res => res.htmlenable === 'T')
        const language = getItemOfSessionStorage(SELECTED_LANG);
        return <div>
            <div class="white_detail_card">
                <div class="p-3 d-flex flex-column">
                    <div>
                        <h6 class="primary_color">{data?.stepsdata[0]?.title}</h6>
                    </div>
                    {data.stepsdata[0] === undefined ? <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                        {t('nodata')}
                    </p> : crrdata?.length !== 0 ? data.stepsdata[0]?.metainfo.filter(res => res.htmlenable === 'T').map(response => {
                        return (
                            <div class="mt-3">
                                <div class="d-flex flex-row width100">
                                    {/* <label class="primary_14 width15">{res.metaname}</label> */}
                                    {/* <p dangerouslySetInnerHTML={{ __html: language === 'en' ? response.metavalue : response.metavaluear }} class=""> */}
                                    <p>
                                        {parse(language === 'en' ? response.metavalue : response.metavaluear)}
                                    </p>
                                </div>

                            </div>

                        )
                    }) : data.stepsdata[0]?.metainfo.map(res => {
                        return (
                            <div class="mt-3">
                                <div class="d-flex flex-row width100">
                                    <label class="primary_14 width15">{language === 'en' ? res.metaname : res.metanamear}</label>

                                    <p class=""> {language === 'en' ? res.metavalue : res.metavaluear}
                                    </p>
                                </div>

                            </div>
                        )
                    })
                    }


                    <hr />

                    <div class="mt-3">
                        <div>
                            <label>Did you find the answer?</label>
                        </div>
                        <div>
                            <span className='pointer' onClick={() => navigate('/home/index')}><img src={process.env.PUBLIC_URL + "/assets/images/Thumbs_up.svg"} alt="Thumbs UP" /></span>
                            <span className='pointer' onClick={() => setProblems(true)}><img src={process.env.PUBLIC_URL + "/assets/images/Thumbs_down.svg"} alt="Thumbs Down" /></span>
                        </div>
                    </div>
                </div>
            </div>
            {problems &&
                <>
                    <div class="mt-4">
                        <div class="form-group">
                            <label class="control-label">Please share your location</label>
                        </div>
                        <button class="custom_btn custom_btn_primary_outline btn_block mb-4" onClick={() => getGeloLocation(data)}>Locate Me</button>
                    </div>

                    <div class="mt-4">
                        <div class="form-group mb-4">
                            <label class="control-label">Tell me more about the problem</label>
                            <textarea class="form-control" onChange={(e) => data.onchange(e)} name="desc" value={data?.apidata?.desc}></textarea>
                            {
                                data?.apidata?.desc === "" && data?.error && <p className='text-danger'>Please Enter user message</p>
                            }
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="form-group mb-4">
                            <label class="control-label">Mobile Number</label>
                            <input value={data.phoneNumber?.replace('965', '')} name="mobileNumber" type="text" maxlength="20" class="form-control" placeholder="" disabled />
                        </div>
                    </div>
                    <div class="d-flex justify-content-around mb-5 mt-5">
                        <button type="button" class="custom_btn custom_btn_primary_outline" onClick={() => setProblems(false)}>cancel</button>
                        <button type="button" class="custom_btn custom_btn_primary" onClick={() => data.submitData()}>Proceed</button>
                    </div>
                </>
            }
        </div>
    }
    if (type === 18) {
        //console.log(data, "dataserss")
        return <div className="card_style_2 height_100 pointer">
            <div className="card_img">
            {data?.bestseller === "True" && <div className="offer-icon-tag">
                    <img src={process.env.PUBLIC_URL + '/assets/images/star.svg'} alt="" title="" />
                </div>}
                {/* <img src={process.env.PUBLIC_URL + '/assets/images/dummy_img_square.png'} alt="" title="" /> */}
                <img src={data?.thumbnail} alt="" title="" />
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    {/* <h4>Anghami Music</h4> */}
                    <h4>{data?.name}</h4>

                    <h6><span dir='ltr'>{data?.currency?.toString() || ''} {data?.price || ''}{data?.validity && `/${data?.validity?.toString()?.toLowerCase()}` || ''}</span></h6 >
                    {/* <h6>KD 0.35/Week</h6> */}
                </div>
                <div className="card_link flex_grp_align_center">
                    {/* <div className="amount_stripe me-2">
                                23 KD /month
                            </div> */}
                    <div className="hyperlink">
                        {/* Activate Now */}
                        {data?.buttontext}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>
    }

    // Special deails home page - Postpaid
    if (type === 19) {
        const handleViewDealClick = (e) => {
            e.preventDefault();

            // navigate(`/special-deals-detail/${data?.offercode}`, {
            //     state: { psmItem: psmItem },
            // });
            try {
                GTM_Select_Item(data, "Special_Deals");
            } catch { }
            navigate(`/selected-special-deal-detail/${data?.offercode}`, {
                state: { psmItem: psmItem, msisdn: loginmsisdn, specialOfferFlagActive: true },
                });
        }

        return (
            <div className="card_style_2 height_100" onClick={handleViewDealClick}>
                <div className="card_img">
                    {data?.fifa && <div className="offer_placeholder end-0 top-0">
                        <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                    </div>}
                    <img src={data?.image || process.env.PUBLIC_URL + '/assets/images/s-internet.svg'} alt="" title="" />
                </div>
                <div className="card_info">
                    <div className="card_info_grp">
                        <h4>{data.title}</h4>
                        <p>{data.description}</p>
                    </div>
                    <div className="card_link flex_grp_align_ce;nter" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="amount_stripe me-2">
                            {data?.offerdiscountprice && `KD${data?.offerbaseprice}`}
                        </div>
                        <div className="hyperlink">
                            {/* {data?.currency || ''} {data?.amount || ''} {data?.validity && `/${data?.validity}` || ''} */}
                            {data?.actionbutton}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (type === 20) {
        const handleViewDealClick = (e) => {
            e.preventDefault();
            try {
                GTM_Select_Item(data);
            } catch { }
            navigate(`/roaming-deals-detail/${data?.offerid}`, {
                state: { psmItem: psmItem, page: 'roaming-multi-country', categoryId: categoryId, categoryId_ar: categoryId_ar, categoryId_en: categoryId_en, bgColor: bgColor },
            })
        };

return <div className="card_style_2 pointer height_100" onClick={handleViewDealClick}>
            <div className="card_img">
                <img src={data?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.title}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    <div className="hyperlink" onClick={handleViewDealClick}>
                        {data?.currency} {data?.offerdiscountprice || data?.offerbaseprice || ''}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>
    }
    if (type === 21) {
        return <>
            <div className="card_style_6 height_100">
                <div className="card_offer1 VideoPopup">
                    <a onClick={toggleModal}>
                        <img src={process.env.PUBLIC_URL + '/assets/images/circle_play.svg'} alt="" title="" />
                    </a>
                </div>
                <div className="card_img">
                    <div className="imgoverly"></div>
                    <img src={process.env.PUBLIC_URL + '/assets/images/check_image.png'} alt="" title="" />
                </div>
                <div className="card_info text-center">
                    <div className="card_info_grp">
                        <label>International Money Transfer </label>
                    </div>
                </div>
            </div>
            <VideoModalComponent show={showModal} toggleModal={toggleModal} />
        </>
    }



    // nojoom - hot-deals-card 
    if (type === 22) {
        return <HotDealsCard data={data} />
    }

    // nojoom - partners-card 
    if (type === 23) {
        return <PartnersCard data={data} />
    }

    // nojoom - services-card 
    if (type === 24) {
        return <ServicesCard data={data} />
    }

    // nojoom - earn-points-card 
    if (type === 25) {
        return <EarnPoints data={data} />
    }
    //ooredeo rewards

    if (type === 26) {

        
       

        const addonFunction = (data) => {
            try { nojoomProductViewed(data?.title) } catch { }
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            try {
                GTM_Select_Item(data, "OoredooServices")
            } catch { }
            
            if(giftnumber){
                navigate(`/ooredeorewards-details/${data.id !== undefined && data.id}?giftnumber=${giftnumber}`, { state: data })
            }else{
                navigate(`/ooredeorewards-details/${data.id !== undefined && data.id}`, { state: data })
            }
        }

        const nojoomProductViewed = (_itemName) => {
            try {
              RecordlogEvents('Nojoom Product Viewed', {
                'Mobile Number': userdata?.msisdn,
                'Product Viewed': _itemName,
                Status: "Success",
                'Status Description': "Success",
                'Login Type': logintype,
              });
            } catch (e) {
            }
        };

        return <div className="card_style_2 height_100 pointer" onClick={() => addonFunction(data)}>
            <div className="card_img">
                {data?.fifa && <div className="offer_placeholder end-0 top-0">
                    <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                </div>}
                <img src={data?.image !== undefined ? data?.image : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')} alt="" title="" />

            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.title}</h4>
                    <p>{data?.desc}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    <div className="hyperlink">
                        {' '}{data?.points}{' '}{t("points")}{' '}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>
    }

    // nojoom - transfer-points 
    if (type === 27) {
        return <TransferPointsCard data={data} />
    }
    //Transfer points
    if (type === 29) {
        console.log(data, "datadatadata")
        const addonFunction = (data) => {
            const crrdata = {
                category: data?.name,
                category_ar: data?.name_ar,
                membershipid: data?.membershipid,
                id: data?.id,
                infotype: data?.infotype,
                previewimage: data?.previewimage

            }
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            try {
                GTM_Select_Item(data, "transferPoints");
            } catch { }
            navigate(`/${data?.buttonurl}`, { state: crrdata })
        }

        const handleTransferCard = (e, url) => {

            const settingsArr = globalSetting
            ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
            : [];
            
              try{
               var _enableExclusiveForNojoomTransfer =  getGlobalSettingValue('enableexclusivefornojoomtransfer_web', settingsArr);
               var _deepLink = getGlobalSettingValue('enableexclusivefornojoomtransferdeeplink_web', settingsArr);
               setDeeplinktext(_deepLink);              
               if(_enableExclusiveForNojoomTransfer != null && _enableExclusiveForNojoomTransfer != ""
               && _enableExclusiveForNojoomTransfer != undefined && (_enableExclusiveForNojoomTransfer == true || _enableExclusiveForNojoomTransfer === "true")){
                setShowModal(true);
                return false;
               }  
            
               }catch{}

            if (getItemOfSessionStorage(IS_2FA_DONE) === 'true') {
                addonFunction(data);
            } else {
              dispatch(setShowEnableMediumAuthBtn(false));
              dispatch(setShowGetKuwaitAppBtn(false));
              //dispatch(setClickedTrasferPointsCardData(data));
              const crrdata = {
                category: data?.name,
                category_ar: data?.name_ar,
                membershipid: data?.membershipid,
                id: data?.id,
                infotype: data?.infotype,
                previewimage: data?.previewimage,
                redirecturl: data?.buttonurl
              }
              dispatch(setClickedTrasferPointsCardData(crrdata));
              dispatch(setShowAuthModal(true));
              dispatch(
                setAuthModalContent({
                  icon: getGlobalSettingValue('beforeverificationicon_web', settingsArr),
                  title: getGlobalSettingValue('beforeverificationtitle', settingsArr),
                  message: getGlobalSettingValue('beforeverificationmsg', settingsArr),
                  btnText: getGlobalSettingValue(
                    'beforeverificationbuttontext',
                    settingsArr
                  ),
                })
              );
            }
          };

          return (<><div className="card_style_2 height_100 pointer" onClick={(e) => {
                // addonFunction(data)}
                  handleTransferCard(e, data?.buttonurl);
                }}
        >
            <div className="card_img">
                {data?.fifa && <div className="offer_placeholder end-0 top-0">
                    <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                </div>}
                <img src={data?.image !== undefined ? data?.image : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')} alt="" title="" />

            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.name}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    <div className="hyperlink">
                        {data?.buttontext}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>

    <ExclusiveModal
        show={showModal}
        toggleModal={toggleModal}
        deeplinktext={deeplinktext}
      /> </>)

    }

    // nojoom - transfer-points 
    if (type === 27) {
        return <TransferPointsCard data={data} />
    }
    //Home page -Ooredoo ADD
    if (type === 28) {
        return <SquarecardComponent data={data} type={1} />
    }
    // recemt- transaction
    if (type === 30) {
        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            console.log(data?.metametaList?.ispurchaseallowed, "data?.metametaList?.ispurchaseallowed")
            try {
                GTM_Select_Item(data)
            } catch { }
            // console.log({data.id, "data.id")
                if (data?.metametaList?.ispurchaseallowed) {
                    navigate(`/recent-Transaction-detail`, { state: data })
                } else {
                    setRecentModal(true)
                }
         
        }
        return <>
            <div className="dls13_card_style2 mb-2" onClick={() => addonFunction(data)}>
                <div className="d-flex card_style_2 height_100 align-item-center">
                    <div className="com-wl">
                        <div className="sec001">
                            <div class="card_img">
                                <img src={data?.icon} alt="" title="" />
                            </div>
                            <div className="card_info">
                                <div className="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p className="mt-2">
                            {data?.description}
                        </p>
                    </div>
                    <div className="vr"></div>
                    <div className="card_link flex_grp_align_center com-wr">
                        <a class="hyperlink">
                            {GetMoreText(data)}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    </div>
                </div>
            </div>
            <MessageModal type="10" show={recentModal} message={t("offer_not_purchasable")}
                handleOk={recnetTogalModal} toggleModal={recnetTogalModal} />
        </>
    }

    //recent transtion new design for only home page
    if (type === 31) {
        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            console.log(data?.metametaList?.ispurchaseallowed, "data?.metametaList?.ispurchaseallowed")
            try {
                GTM_Select_Item(data)
            } catch { }
            if (data?.metametaList?.ispurchaseallowed) {
                navigate(`/recent-Transaction-detail`, { state: data })
            } else {
                setRecentModal(true)
            }

        }
        return <>
            <div className="" onClick={() => addonFunction(data)}>
                <div className="flex-column height_100 align-item-center">
                    <div className="com-wl w-100">
                        <div className="sec001">
                            <div class="card_img">
                                <img src={getImgSrc(data?.icon, true)} alt="" title="" />
                            </div>
                            <div className="card_info">
                                <div className="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p className="mt-2 h3_title_restrct">
                            {data?.description}
                        </p>
                    </div>
                    <hr></hr>
                    <div className="card_link w-100 flex_grp_align_center com-wr">
                        <a class="hyperlink flex_grp_between w-100 d-flex justify-content-between">
                            <div>
                            {GetMoreText(data)}
                            </div>
                            <div>
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'}
                                class="ms-1" alt="" title="" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <MessageModal type="10" show={recentModal} message={t("offer_not_purchasable")}
                handleOk={recnetTogalModal} toggleModal={recnetTogalModal} />
        </>
    }

    if (type === 32) {
        //console.log(data, "dfarer")
        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            try {
                GTM_Select_Item(data, data.category === 'addons' ? "addons" : "bundles")
            } catch { }
            // console.log(data, "data.id")
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            if (data.category === 'bundles') {
                navigate(`/bundles-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })
            } else if (data.category === 'addons') {
                navigate(`/addons-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })
            }
        }
        return <div className="card_style_2 height_100 pointer" onClick={() => addonFunction(data)}>
            <div className="card_img">
                {data?.fifa && <div className="offer_placeholder end-0 top-0">
                    <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                </div>}
                <img src={data?.imageurl !== undefined ? data?.imageurl : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')} alt="" title="" />

            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.title}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    {/* <div className="amount_stripe me-2">
                        {data?.offerdiscountprice !== "" && `KD${data?.offerbaseprice}`}
                    </div> */}
                    <div className="hyperlink">
                        {GetMoreText(data)}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
        </div>
    }

    //ooredoo add new section for DLS
    if (type === 33) {

        const itemclick = (data) => {
            window.open(data?.buyurl, '_blank');
        }

        return (
            <div class="flex-column card_style_2 height_100 align-item-center" onClick={() => itemclick(data)}>
                {data?.ribbonenable === 'T' && (
                    <div
                        class="offer-tag"
                        style={{
                            background: data?.ribbonbgcolor,
                            color: data?.ribbontitlecolor,
                        }}
                        >
                        {data?.ribbontitle}
                    </div>
                )}
                <div class="com-wl w-100">
                    <div class="sec001">
                        <div class="card_img">
                            <img src={data?.imagepath} alt=""></img>
                        </div>
                        <div class="card_info">
                            <div class="card_info_grp">
                                <h4 style={{"direction":isContainAlphabet(data?.title) ? "ltr" :""}}> {data?.title}</h4>
                            </div>
                            <p class="mt-2" style={{"direction":isContainAlphabet(data?.description) ? "ltr" :""}}>
                                {data?.description}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="card_link flex_grp_align_center com-wr">
                    <a href="#" class="hyperlink">
                    {data?.discountprice > 0 ? `${t('kd')} ${data?.discountprice}` : `${t('kd')} ${data?.amount}`}
                    {data?.validity ? `/${data?.validity}` : ''}

                    {
                        (data?.discountprice > 0 && data?.amount) > 0 && (    
                            <span className='text-line-through ms-2'>{(data?.discountprice > 0 && data?.amount > 0) ? `${t('kd')} ${data?.amount}` : ''}</span>
                        )
                    }
                    </a>
                </div>
            </div>
        )
    }
    
    // recent-Transaction-Home - cards
    if (type === 34) {
        let msisdn = customerprofile?.Msisdn;
        const urlParam = `msisdn=${getformatedMsisdn(msisdn)}&offerid=${
            data?.offerid
          }&paytype=${data?.id?.toLowerCase()}&from=recentpurchase`;
          const encryptedUrlParam = RC4Encrypt(urlParam);

        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            console.log('data==>', data, categoryID);
            try {
                GTM_Select_Item(data, data.category);
            } catch { }
            // console.log(data, "data.id")
            // document.body.scrollTop = 0;
            // document.documentElement.scrollTop = 0;
            // if (data.category === 'bundles') {
            //     navigate(`/bundles-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })
            // } else if (data.category === 'addons') {
            //     navigate(`/addons-detail/${data.id !== undefined ? data.rnofferSubGroup : categoryID}`, { state: data })
            // }
            if(data?.metametaList?.ispurchaseallowed){
                navigate(`/shared-offer-details/${encryptedUrlParam}`);
            }else{
                setShowInfoModal(!showInfoModal);
            }
        }
        const  handleClose = ()=>{
            setShowInfoModal(!showInfoModal);
        }
        return <div className="card_style_2 height_100 pointer" onClick={() => addonFunction(data)}>
            <div className="card_img">
                {data?.fifa && <div className="offer_placeholder end-0 top-0">
                    <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
                </div>}
                <img src={data?.imageurl || data?.imagepath || data?.icon || getImgSrc('/assets/images/s-internet.svg')} alt="" title="" />
                {/* <img src={data?.imageurl !== undefined ? data?.imageurl : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')} alt="" title="" /> */}
            </div>
            <div className="card_info">
                <div className="card_info_grp">
                    <h4>{data?.title}</h4>
                    <p>{data?.description}</p>
                </div>
                <div className="card_link flex_grp_align_center">
                    {
                        data?.offerdiscountprice && (
                            <div className="amount_stripe me-2">
                                {data?.offerdiscountprice !== "" && `KD${data?.offerbaseprice}`}
                            </div>
                        )
                    }
                    <div className="hyperlink">
                        {GetMoreText(data)}
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                    </div>
                </div>
            </div>
             <BottomModalComponent show={showInfoModal} popuptype="info"  togglebottomModal={handleClose}/>
        </div>
    }

    //nojoom component banner
    if(type === 35){
        const imagePath = data?.path || '';
        const isServerUrl = (data?.path) ? true : false;

        const handleRedirection = (path, isExternal)=> {
            if(path){
                if(path.includes('https://') || path.includes('http://')){
                  if(isExternal){
                    window.open(path, '_blank');
                  }else{
                    window.location.href = path;
                  }
                }else{
                    if(path.toLowerCase() === 'recharge'){
                        redirecturl(`/${path}`, navigate); 
                    }else{
                        //redirecturl(path, navigate); 
                          navigate('/' + path);
                          return false;
                    }
                }
            }
          } 

        return(
            <div className="flex-column height_100 align-item-center">
                <div className="com-wl w-100 mb-4">
                <img 
                    className="w-100"
                    src={getImgSrc(imagePath, isServerUrl)} 
                    onClick={()=>handleRedirection(data?.url, data?.external)} 
                />
                </div>
            </div>)
    }

    if(type === 36){
        return <div>
            <div class="dls13_card_style2 mb-2">
                <div class="d-flex card_style_2 height_100 align-item-center">
                    <div class="com-wl">
                        <div class="sec001">
                            <div class="card_img">
                                <img src={data?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
                            </div>
                            <div class="card_info">
                                <div class="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-2">{data?.description}</p>
                    </div>


                    <div class="vr"></div>

                    <div class="card_link flex_grp_align_center com-wr">
                        <a href="#" class="hyperlink">
                            {data?.currency} {data?.offerdiscountprice || data?.offerbaseprice || ''}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    }

    //recent purchases home with length one
    if (type === 37) {
        const GetMoreText = itemdata => {
            try {
                if (
                    itemdata?.offerdiscountprice != null &&
                    itemdata?.currency != null &&
                    itemdata?.offerdiscountprice != ''
                ) {
                    return itemdata.currency + ' ' + itemdata.offerdiscountprice;
                } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
                    return itemdata.currency + ' ' + itemdata.offerbaseprice;
                } else {
                    return itemdata?.actiontext;
                }

            } catch (e) { }

            return '';

        };
        const addonFunction = (data) => {
            console.log(data?.metametaList?.ispurchaseallowed, "data?.metametaList?.ispurchaseallowed")
            try {
                GTM_Select_Item(data)
            } catch { }
            // console.log({data.id, "data.id")
            if (data?.metametaList?.ispurchaseallowed) {
                navigate(`/recent-Transaction-detail`, { state: data })
            } else {
                setRecentModal(true)
            }

        }

        return <><div onClick={() => addonFunction(data)}>
            <div class="dls13_card_style2 mb-2">
                <div class="d-flex card_style_2 height_100 align-item-center">
                    <div class="com-wl">
                        <div class="sec001">
                            <div class="card_img">
                                <img src={getImgSrc(data?.icon, true)} alt="" title="" />
                            </div>
                            <div class="card_info">
                                <div class="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-1">{data?.description}</p>
                    </div>


                    <div class="vr"></div>

                    <div class="card_link flex_grp_align_center com-wr">
                        <a href="#" class="hyperlink">
                            {GetMoreText(data)}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <MessageModal type="10" show={recentModal} message={t("offer_not_purchasable")}
                handleOk={recnetTogalModal} toggleModal={recnetTogalModal} />
        </>
    }
    if (type === 38) {
        const handleViewDealClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/roaming_product_details/${data?.offerid}`, {
                state: { psmItem: psmItem, sourceId: sourceId },
            })
        };

        const handleClick = (e) =>{
            e.stopPropagation();
            setShowBottomModal(!showBottomModal);
        }

return  <div>
            <div className='products_card' onClick={(e)=>handleViewDealClick(e)}>
                    <div className='card_info'>
                        <div className='lft_card'>
                            <div className='fst_card'>
                                <img src={data?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
                                <h5>{data?.title}</h5>
                            </div>
                            <p>{data?.description}</p>
                        </div>
                        <div class="vr"></div>
                        <div className='rgt_card'>
                            <div>
                                <div className='primary_price'>
                                    <h6>{data?.currency} {data?.offerdiscountprice || data?.offerbaseprice || ''}</h6>
                                </div>
                            </div>
                            <div className='hyperlink'>
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </div>
                            {/* 
                            <div className='secondary_price'>
                                KD 40
                            </div>*/}
                        </div>
                    </div>
                    {data?.supportedcountries?.isenable === "T" && 
                        <h6 className='cardsupport_txt' onClick={(e)=>handleClick(e)}>
                            {data?.supportedcountries?.title}
                        </h6>
                    }
                </div>
            {showBottomModal &&  <ViewSupportedCountriesSlider data={data} psmItem={psmItem} sourceId={sourceId} handleClick={handleClick} setShowBottomModal={setShowBottomModal}/>}
        </div>
    }
 
    if (type === 39) {
        const handleViewDealClick = (e) => {
            e.preventDefault();
            navigate(`/roaming_product_details/${data?.offerid}`, {
                state: { psmItem: psmItem, sourceId: sourceId },
            })
        };

        return <div onClick={handleViewDealClick}>
            <div class="dls13_card_style2 mb-2">
                <div class="d-flex card_style_2 height_100 align-item-center">
                    <div class="com-wl">
                        <div class="sec001">
                            <div class="card_img">
                                <img src={data?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
                            </div>
                            <div class="card_info">
                                <div class="card_info_grp">
                                    <h4>{data?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-1">{data?.description}</p>
                    </div>


                    <div class="vr"></div>

                    <div class="card_link flex_grp_align_center com-wr">
                        <a class="hyperlink">
                            {data?.currency} {data?.offerdiscountprice || data?.offerbaseprice || ''}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    }
 
}
export default CardsComponent;
